import { Languages } from "src/common/descriptions/types";
import { CreateCashboxCategoryDescriptions } from "./types";

const DescriptionsEnUs: CreateCashboxCategoryDescriptions = {
    EDIT_TITLE: "Edit Category",
    TITLE: "Create Category",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Cashbox Category?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Cashbox Category input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Cashbox Category Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Cashbox Category Updated",
    },
    FORM: {
        NAME: {
            LABEL: "Name",
            PLACEHOLDER: "Input name",
        },
        DESCRIPTION: {
            LABEL: "Description",
            PLACEHOLDER: "Input description",
        },
        TYPE: {
            LABEL: "Type",
            PLACEHOLDER: "Select type",
        },
    },
    MAIN_ACTION_TITLE: "Creating Cashbox Category",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    INCOME: "Income",
    OUTCOME: "Outcome",
}

const DescriptionsEsUs: CreateCashboxCategoryDescriptions = {
    EDIT_TITLE: "Editar Categoría",
    TITLE: "Crear Categoría",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Categoría con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Categoría?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Categoría creada",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Categoría Actualizada",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre",
            PLACEHOLDER: "Ingrese nombre",
        },
        DESCRIPTION: {
            LABEL: "Descripción",
            PLACEHOLDER: "Ingrese descripción",
        },
        TYPE: {
            LABEL: "Tipo",
            PLACEHOLDER: "Seleccione tipo",
        },
    },
    MAIN_ACTION_TITLE: "Creando Categoría",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    INCOME: "Ingreso",
    OUTCOME: "Salida",
}

export const createCashboxCategoryDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}